/**
 * in this module there are all the related functions for:
 *  - initialize the layer
 *  - add the layer to the map
 *  - initialize the datepicker
 */
/**
 * import modules
 */
import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'
import TileGrid from 'ol/tilegrid/TileGrid'
import functions from '../common/functions'
import map from '../common/map'


/**
 * global vars
 */

let frafeatlayer = ''
let sQLayers
var pageconfig = JSON.parse($('#pageconfig').val())
/**
 * create the fra layer
 */

let initFraLayer = () => {
  /**
   * get the settings from the functions module
   * update the vars accordingly
   */
  /**
   * set the correct layers
   */

   sQLayers = functions.getLayerList('fra')
   if (sQLayers === '') {
     // no parking layers so end function
     return
   }
  /**
   * get resolutions from scale
   */

  // final resolutions array
  const resolutions = []
  // temp scale array
  const scaleArray = []
  // scales array
  const scales = pageconfig.scales.split(',')
  // create a temporary array of scales in number
  functions.getScale(scales, scaleArray)
  // create the final resolutions array
  functions.setResolution(scaleArray, resolutions)

  /**
  * get the extent of the visible map
   */
  //let layerinfo = pageconfig.layers.find(el => el.layers === "fra")
  //this wont work on ie11 so need to use function below

  var layerinfo = functions.altFind(pageconfig.layers, function(e) {
    return e.layers === "fra"
  })

  const setExt = pageconfig.bounds.split(',')
  const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]

  /**
   * get the current date
   * set the default date to display the restrictions
   */

  const today = new Date()
  let sDTo = `${today.getFullYear()}-${functions.leadZero(today.getMonth() + 1)}-${functions.leadZero(today.getDate())}`

  /**
   * initialize suspid
   * get the url parameters
   */

  let suspid
  let urlpos = window.location.search.replace('?', '')

  /**
   * check if in the URL you have the suspid parameter
   * PSA staff website
   * https://www.traffwebdev.uk/psastaff/index.html?suspid=c123456354673
   */

  if (urlpos.search('suspid') > -1 && urlpos.search('defpos') === -1) {
    let sFindID = urlpos.replace('suspid=', '')
    suspid = sFindID
  }

  // dummy parameter to use for FRA
  let iDelRef = 0

  // feature layer
  frafeatlayer = new TileLayer({
    // this extent limit the visible map
    name: 'fra',
    className: 'featlayer',
    extent: ext,
    // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
    preload: Infinity,
    source: new TileWMS({
      url: layerinfo.wmsfeat,
      params: {
        'LAYERS': sQLayers,
        MYORDERS: $('#frapsafeatclick').val(),
        DTO: sDTo,
        FREF: iDelRef,
        format: 'image/png'
      },
      ratio: 1,
      gutter: 40,
      serverType: 'mapserver',
      crossOrigin: 'anonymous',
      projection: 'EPSG:27700',
      tileGrid: new TileGrid({
        resolutions: resolutions,
        extent: ext,
        tileSize: [128, 128]
      })
    })
  })


  /**
   * end let initPmLayer = () => {
   */
}

/**
 * update the parkmap layer parameters
 */

const updateLayerParams = (sOrderSel, iDelRef) => {
  /**
   * hide the layer
   */
  //check for accident layers otherwise return
  if (functions.getLayerList('fra') === '') {return}

  frafeatlayer.setVisible(false)

  /**
   * if the visible restriction array is empty stop and return
   */

  if (sOrderSel.length === 0) {
    return
  }

  /**
   * get the date from the datepicker
   * convert the date from the datepicker to a PG format
   * once is converted it can be use as a parameter
   */

  let dDTo = ''
  const today = new Date()

  if ($('#activedate').val()) {
    dDTo = $('#activedate').val().split('/').reverse().join('-')
  }
  else {
    dDTo = `${today.getFullYear()}-${functions.leadZero(today.getMonth() + 1)}-${functions.leadZero(today.getDate())}`
  }


  /**
   * update the restrictions to dipslay
   * update the date
   * refresh the source
   * show the layer
   */

  frafeatlayer.getSource().getParams().MYORDERS = sOrderSel
  frafeatlayer.getSource().getParams().DTO = dDTo
  frafeatlayer.getSource().getParams().FREF = iDelRef
  frafeatlayer.getSource().refresh()
  frafeatlayer.setVisible(true)
  map.getMapTab()
/**
 * end const updateLayerParams = (sOrderSel, iDelRef) => {
 */
}

/**
 * export the layers
 */

const fralayer = () => {
  return frafeatlayer
}

/**
 * export the addlayer
 */

const addlayer = () => {
  //check for parking layers otherwise return
  if (functions.getLayerList('fra') === '') {return}
  map.getMap().addLayer(frafeatlayer)
  frafeatlayer.setZIndex(2)
}

/**
 * EXPORT
 */

export default {
  updateLayerParams,
  addlayer,
  fralayer,
  initFraLayer
}
